import { 
    CREATERADIOLOGYOPDTEST,
    CREATERADIOLOGYTEST, 
    CREATERADIOLOGYTESTPARAMETER, 
    DELETERADIOLOGYOPDTEST, 
    DELETERADIOLOGYTEST, 
    DELETERADIOLOGYTESTPARAMETER, 
    GETRADIOLOGYOPDTEST, 
    GETRADIOLOGYTEST, 
    GETRADIOLOGYTESTPARAMETER,
    UPDATERADIOLOGYOPDTEST,
    UPDATERADIOLOGYTEST, 
    UPDATERADIOLOGYTESTPARAMETER 
    } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATERADIOLOGYTEST:
            return {
                ...state,
                radiologytestSaveStatus: action.payload.success,
            }
        case GETRADIOLOGYTEST:
                return {
                        ...state,
                        radiologytestList: action.payload.data,
                        }
      
        case UPDATERADIOLOGYTEST:
                return {
                        ...state,
                        radiologytestUpdateStatus: action.payload.success,
                        }   

        case DELETERADIOLOGYTEST:
                 return {
                     ...state,
                     radiologytestDeleteStatus: action.payload.success,
                        } 

        case CREATERADIOLOGYTESTPARAMETER:
            return {
                ...state,
                radiologytestparameterSaveStatus: action.payload.success,
            }
            case GETRADIOLOGYTESTPARAMETER:
                return {
                        ...state,
                        radiologytestparameterList: action.payload.data,
                        }
      
        case UPDATERADIOLOGYTESTPARAMETER:
                return {
                        ...state,
                        radiologytestparameterUpdateStatus: action.payload.success,
                        }   

        case DELETERADIOLOGYTESTPARAMETER:
                 return {
                     ...state,
                     radiologytestparameterDeleteStatus: action.payload.success,
                        } 

       case CREATERADIOLOGYOPDTEST:
            return {
                ...state,
                opdradiologytestSaveStatus: action.payload.success,
            }
        case GETRADIOLOGYOPDTEST:
                return {
                        ...state,
                        opdradiologytestList: action.payload.data,
                        }
      
        case UPDATERADIOLOGYOPDTEST:
                return {
                        ...state,
                        opdradiologytestUpdateStatus: action.payload.success,
                        }   

        case DELETERADIOLOGYOPDTEST:
                 return {
                     ...state,
                     opdradiologytestDeleteStatus: action.payload.success,
                        } 
                        default:
                            return state
                             }
                         }